module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_Transition_00111.e596d5ea.png";